import { render, staticRenderFns } from "./Y67TSecondaryDataTable.vue?vue&type=template&id=367d8d02&scoped=true&"
import script from "./Y67TSecondaryDataTable.vue?vue&type=script&lang=js&"
export * from "./Y67TSecondaryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./Y67TSecondaryDataTable.vue?vue&type=style&index=0&id=367d8d02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d8d02",
  null
  
)

export default component.exports